<template>
  <m-form
    :title="title"
    :items="items"
    :cols="cols"
    :show-clear-btn="false"
    :canSubmit="canSubmit"
    :canDelete="canDelete"
    :is-editing.sync="isEditing"
    :showListBtn="false"
    :show-navigation-btns="false"
    @click:row="setItem"
    @clearForm="clearForm"
    @submit="submit"
    @delete="deleteItem"
    ref="form"
  >
    <template #header-btns>
      <v-btn
          depressed
          class="secondary rounded-lg white--text mr-1 "
          :to="`/panel/defaultAccounts/factor`"
      >حساب
      </v-btn>
      <v-btn
          depressed
          class="secondary rounded-lg white--text mr-1 "
          :to="`/panel/defaultTexts/factor`"
      >پی نوشت
      </v-btn>
      <v-btn
          depressed
          :color="(factorType=='buy')?'primary':'secondary'"
          class="rounded-lg white--text mr-1 "
          @click="goBuy"
      >هزینه های خرید
      </v-btn>
      <v-btn
          depressed
          :color="(factorType=='sale')?'primary':'secondary'"
          class=" rounded-lg white--text mr-1 "
          @click="goSale"
      >هزینه های فروش
      </v-btn>
    </template>

      <template #default>
      <v-row>
        <v-col cols="12">
          <v-text-field class="rounded-lg" label=" * نام" v-model="item.name" :disabled="!isEditing" />
        </v-col>
        <v-col cols="12">
          <account-select
            label=" * حساب"
            itemsType="level3"
            v-model="item.account"
            :disabled="!isEditing"
            :floatAccount1.sync="item.floatAccount1"
            :floatAccount2.sync="item.floatAccount2"
            :floatAccount3.sync="item.floatAccount3"
            :floatAccount4.sync="item.floatAccount4"
          />
        </v-col>
        <v-col cols="12">
          <v-textarea class="rounded-lg" label="توضیحات" v-model="item.explanation" :disabled="!isEditing" />
        </v-col>
      </v-row>
    </template>
  </m-form>
</template>
<script>
import { fromCodeFilter, toCodeFilter } from "@/mixin/accountMixin.js";
import { MFormMixin } from "@/components/m-form";
import GetFactorExpenseApi from "./getFactorExpensesApi";

export default {
  mixins: [MFormMixin, GetFactorExpenseApi],
  props: {
    factorType: {
      requried: true
    }
  },
  data() {
    return {
      item: {},
      baseUrl: "factors/expenses",
      permissionBasename: "factorExpenses",
      appendSlash: true,
      cols: [
        {
          text: "نام",
          value: "name",
          type: "text",
          filters: ["name"]
        },
        {
          text: "حساب",
          value: "account.title",
          type: "text",
          filters: ["account__title__icontains"]
        }
      ]
    };
  },
  computed: {
    title() {
      let title = " پیشفرض های فاکتور > ";
      if (this.factorType == "sale") return title + "هزینه های فروش";
      else return title + "هزینه های خرید";
    },
    items() {
      return this.factorExpenses.filter(o => o.type == this.factorType);
    }
  },
  methods: {
    goBuy(){
      if(this.factorType == 'buy'){
        this.clearForm()
      } else {
        this.$router.push(`/panel/factor/expenses/buy`)
      }
    },
    goSale(){
      if(this.factorType == 'sale'){
        this.clearForm()
      } else {
        this.$router.push(`/panel/factor/expenses/sale`)
      }
    },
    getItemTemplate() {
      return {
        level: this.level,
        type: this.factorType
      };
    },
    getData() {
      this.getFactorExpenses(true);
    },
    setItem(item) {
      this.item = item;
    },
    getSerialized() {
      let item = this.extractIds(this.item);
      item.type = this.factorType;
      return item;
    }
  }
};
</script>